import AnalysisMatchBasket from "./AnalysisMatchBasket";


export default class AnalysisBasket { 

    data = null;
    history = null;
    recent = null;
    count = null;
    recentCount = null;

    homeId = null;
    awayId = null;
    leagueId = null;

    constructor(t) {
        this.data = t;
        this.homeId = this.getMatchHomeId();
        this.awayId = this.getMatchAwayId();
    }

    getMatchHomeId() {
        if (this.data && this.data.info && this.data.info.length > 6 && this.data.info[6] && this.data.info[6].length > 0) {
            return this.data.info[6][0]
        }
        return null;
    }

    getMatchAwayId() {
        if (this.data && this.data.info && this.data.info.length > 7 && this.data.info[7] && this.data.info[7].length > 0) {
            return this.data.info[7][0]
        }
        return null;
    }

    getMatchLeagueId() {
        if (this.data && this.data.info && this.data.info.length > 2) {
            return this.data.info[2];
        }
        return null;
    }

    getMatchHomeName(homeId) {
        if (!homeId) {
            homeId = this.getMatchHomeId();
        }
        let teams = this.getTeams();
        if (teams[homeId]) {
            return teams[homeId].name_zh;
        }
        return '';
    }

    getMatchAwayName(awayId) {
        if (!awayId) {
            awayId = this.getMatchAwayId();
        }
        let teams = this.getTeams();
        if (teams[awayId]) {
            return teams[awayId].name_zh;
        }
        return '';
    }

    getMatchLeagueName(leagueId) {
        let league = this.getLeague();
        if (league[leagueId]) {
            return league[leagueId].name_zh;
        }
        return '';
    }

    getLeague() {
        if (this.data) {
            return this.data.events;
        }
        return null;
    }

    getTeams() {
        if (this.data) {
            return this.data.teams;
        }
        return null;
    }

    getMatchTime() {
        if (this.data && this.data.info && this.data.info[4]) {
            return this.data.info[4];
        }
        return 0;
    }

    getAsia() {
        if (this.data && this.data.info && this.data.info[8] && this.data.info[8][0]) {
            let asia = this.data.info[8][0].split(',');
            if (asia && asia.length > 1) {
                let nasiz = Number(asia[1]);
                return isNaN(nasiz) ? 0 : nasiz;
            }
        }
        return 0;
    }

    getDaxiao() {
        if (this.data && this.data.info && this.data.info[8] && this.data.info[8][2]) {
            let asia = this.data.info[8][2].split(',');
            if (asia && asia.length > 1) {
                let nasiz = Number(asia[1]);
                return isNaN(nasiz) ? 0 : nasiz;
            }
        }
        return 0;
    }


    getMatch(data) {
        let anslysis = new AnalysisMatchBasket(data);
        anslysis.homeName = this.getMatchHomeName(anslysis.homeId);
        anslysis.league = this.getMatchLeagueName(anslysis.league);
        anslysis.awayName = this.getMatchAwayName(anslysis.awayId);
        anslysis.isHome = this.homeId == anslysis.homeId;
        anslysis.calcAsiaDx();
        return anslysis;
    }

    getHomeId(data) {
        return data[6] ? data[6][0] : null;
    }

    getHistory(historySameSide) {
        let list = [];
        if (this.data && this.data.result && this.data.result.vs) {
            let data = this.data.result.vs;
            for (let i = 0; i < data.length; i++) {
                let analysis = this.getMatch(data[i]);
                if (historySameSide) {
                    if (this.getMatchHomeId() == analysis.homeId && this.getMatchAwayId() == analysis.awayId) {
                        list.push(analysis);
                    }
                } else {
                    list.push(analysis);
                }
            }
        }
        return list;
    }

    getAnalysisCount(list, isHome) {
        let win = 0;
        let fail = 0;
        let draw = 0;
        let asiaWin = 0;
        let asiaFail = 0;
        let asiaDraw = 0;

        let da = 0;
        let xiao = 0;
        let zou = 0;

        for (let i = 0; i < list.length; i++) {
            let homeScore = list[i].isHome ? list[i].homeScore : list[i].awayScore;
            let awayScore = list[i].isHome ? list[i].awayScore : list[i].homeScore;
            if (homeScore > awayScore) {
                win++;
            } else if (homeScore < awayScore) {
                fail++;
            } else {
                draw++;
            }

            if (list[i].asiaResult > 0) {
                asiaWin++;
            } else if (list[i].asiaResult < 0) {
                asiaFail++;
            } else {
                asiaDraw++;
            }

            if (list[i].daxiaoResult > 0) {
                da++;
            } else if (list[i].daxiaoResult < 0) {
                xiao++;
            } else {
                zou++;
            }
        }

        let wlv = (win + fail + draw) == 0 ? '0%' : (win / (win + fail + draw) * 100).toFixed(2) + "%";
        let alv = (asiaWin + asiaFail + asiaDraw) == 0 ? '0%' : (asiaWin / (asiaWin + asiaFail + asiaDraw) * 100).toFixed(2) + "%";
        let dlv = (da + xiao + zou) == 0 ? '0%' : (da / (da + xiao + zou) * 100).toFixed(2) + "%";
        return {
            win: win,
            fail: fail,
            draw: draw,
            winLv: wlv,
            asiaWin: asiaWin,
            asiaFail: asiaFail,
            asiaDraw: asiaDraw,
            asiaLv: alv,
            da: da,
            xiao: xiao,
            zou: zou,
            dxLv: dlv,
        }
    }

    getRecent(recentHomeSide, recentSameSide, recentSameLeague) {
        let list = [];
        let idx = 0;
        if (recentHomeSide) {
            if (this.data && this.data.result && this.data.result.home) {
                let data = this.data.result.home
                for (let i = 0; i < data.length; i++) {
                    let analysis:any = this.getMatch(data[i]);
                    if (recentSameSide) {
                        if (analysis.homeId == this.homeId) {
                            list.push(analysis);
                            idx++;
                        }
                    } else if (recentSameLeague) {
                        if (this.leagueId == analysis.leagueId) {
                            list.push(analysis);
                            idx++;
                        }
                    } else {
                        list.push(analysis);
                        idx++;
                    }
                    if (idx >= 10) {
                        break;
                    }
                }
            }
        } else {
            if (this.data && this.data.result && this.data.result.away) {
                let data = this.data.result.away;
                for (let i = 0; i < data.length; i++) {
                    let analysis: any = this.getMatch(data[i]);
                    if (recentSameSide) {
                        if (analysis.awayId == this.awayId) {
                            list.push(analysis);
                            idx++;
                        }
                    } else if (recentSameLeague) {
                        if (this.leagueId == analysis.leagueId) {
                            list.push(analysis);
                            idx++;
                        }
                    } else {
                        list.push(analysis);
                        idx++;
                    }
                    if (idx >= 10) {
                        break;
                    }
                }
            }
        }
        return list;
    }

}
